import { render } from "./ProcedenciaList.vue?vue&type=template&id=56f8bc50&scoped=true"
import script from "./ProcedenciaList.vue?vue&type=script&lang=js"
export * from "./ProcedenciaList.vue?vue&type=script&lang=js"

import "./ProcedenciaList.vue?vue&type=style&index=0&id=56f8bc50&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f8bc50"]])

export default __exports__